// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Reader from "../Control.Monad.Reader/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Lazy from "../Data.Lazy/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
import * as Foliage_App_Style from "../Foliage.App.Style/index.js";
import * as Foliage_Example_Blank from "../Foliage.Example.Blank/index.js";
import * as Foliage_Program from "../Foliage.Program/index.js";
import * as Halogen_Component from "../Halogen.Component/index.js";
import * as Halogen_HTML from "../Halogen.HTML/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_Query_HalogenM from "../Halogen.Query.HalogenM/index.js";
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM);
var modify_ = /* #__PURE__ */ Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var render = /* #__PURE__ */ Foliage_Program.render(Foliage_Program["_Render_Module"]);
var bind = /* #__PURE__ */ Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM);
var get = /* #__PURE__ */ Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM);
var pure = /* #__PURE__ */ Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM);
var log = /* #__PURE__ */ Effect_Class_Console.log(/* #__PURE__ */ Halogen_Query_HalogenM.monadEffectHalogenM(Effect_Aff.monadEffectAff));
var GetModule = /* #__PURE__ */ (function () {
    function GetModule(value0) {
        this.value0 = value0;
    };
    GetModule.create = function (value0) {
        return new GetModule(value0);
    };
    return GetModule;
})();
var UpdatedModule = /* #__PURE__ */ (function () {
    function UpdatedModule(value0) {
        this.value0 = value0;
    };
    UpdatedModule.create = function (value0) {
        return new UpdatedModule(value0);
    };
    return UpdatedModule;
})();
var SetModule = /* #__PURE__ */ (function () {
    function SetModule(value0) {
        this.value0 = value0;
    };
    SetModule.create = function (value0) {
        return new SetModule(value0);
    };
    return SetModule;
})();
var component = /* #__PURE__ */ (function () {
    var set_mod = function (mod) {
        return discard(modify_(function (v) {
            var $17 = {};
            for (var $18 in v) {
                if ({}.hasOwnProperty.call(v, $18)) {
                    $17[$18] = v[$18];
                };
            };
            $17.mod = mod;
            return $17;
        }))(function () {
            return Halogen_Query_HalogenM.raise(new UpdatedModule(mod));
        });
    };
    var render1 = function (state) {
        return Halogen_HTML_Elements.div([ Foliage_App_Style.style(append(Foliage_App_Style.font_code)(append(Foliage_App_Style.flex_column)([ "gap: 1.0em" ]))) ])(Data_Array.concat([ [ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.flex_row) ])((function () {
            var button = function (onClick) {
                return function (label) {
                    return Halogen_HTML_Elements.div([  ])([ Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(onClick), Foliage_App_Style.style(Foliage_App_Style.button) ])([ Halogen_HTML_Core.text(label) ]) ]);
                };
            };
            return [  ];
        })()) ], (function () {
            if (state.load_error instanceof Data_Maybe.Nothing) {
                return [  ];
            };
            if (state.load_error instanceof Data_Maybe.Just) {
                return [ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.color_error) ])([ Halogen_HTML_Core.text(state.load_error.value0) ]) ];
            };
            throw new Error("Failed pattern match at Foliage.App.Editor.Component (line 131, column 13 - line 133, column 89): " + [ state.load_error.constructor.name ]);
        })(), [ Halogen_HTML_Elements.div([ Foliage_App_Style.style(append(Foliage_App_Style.flex_column)([ "overflow: scroll" ])) ])((function () {
            var renderCtx = {
                mod: state.mod
            };
            return map(Halogen_HTML.fromPlainHTML)(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(render(state.mod)));
        })()) ] ]));
    };
    var initialState = function (input) {
        return {
            mod: Data_Maybe["fromMaybe$prime"](function (v) {
                return Data_Lazy.force(Foliage_Example_Blank.blank);
            })(input.mod),
            load_error: Data_Maybe.Nothing.value
        };
    };
    var handleQuery = function (v) {
        return bind(get)(function (v1) {
            return pure(new Data_Maybe.Just(v.value0(v1.mod)));
        });
    };
    var handleAction = function (v) {
        return discard(log("[Editor.SetModule]"))(function () {
            return set_mod(v.value0);
        });
    };
    var $$eval = Halogen_Component.mkEval({
        receive: Halogen_Component.defaultEval.receive,
        initialize: Halogen_Component.defaultEval.initialize,
        finalize: Halogen_Component.defaultEval.finalize,
        handleAction: handleAction,
        handleQuery: handleQuery
    });
    return Halogen_Component.mkComponent({
        initialState: initialState,
        "eval": $$eval,
        render: render1
    });
})();
export {
    GetModule,
    UpdatedModule,
    SetModule,
    component
};
